import type { TransportCostAllocationResult } from '../../utils/transportCostAllocation';

// The allocation shown on the transport card is a planning view. It is not the
// ledger that posts PZ/WZ costs. When a selected basis cannot split the whole
// truck cost, rendering the missing share as "0 PLN" is misleading.
export function hasCompleteTransportCostAllocation(
  allocation: { summary: Pick<TransportCostAllocationResult['summary'], 'allocationDifference'> },
): boolean {
  return Math.abs(Number(allocation.summary.allocationDifference) || 0) < 0.005;
}
